<div class="row margin-bottom-30">
    <div class="col-xs-12">
        <ul class="nav nav-pills">
            <li [routerLink]="['email']" routerLinkActive="active"><a>Email</a></li>
            @if (canViewSms) {
                <li [routerLink]="['sms']" routerLinkActive="active"><a>SMS</a></li>
            }
        </ul>
    </div>
</div>

<div class="margin-top-15">
    <router-outlet></router-outlet>
</div>
